import { baseSeriesMark } from "../base/constant";

import { lineLikeSeriesMark } from "../mixin/constant";

export const lineSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), lineLikeSeriesMark);
//# sourceMappingURL=constant.js.map
